import axios, { type AxiosRequestConfig, type AxiosResponse, type Method } from 'axios';

export interface IHttpOptions extends AxiosRequestConfig {
  body?: any;
  data?: any;
  dataType?: any;
  headers?: any;
  method: Method;
  params?: any;
  transformRequest?: any;
  url: string;
}

export function $http(options: IHttpOptions): Promise<AxiosResponse> {
  return new Promise((res, rej) => {
    // Add any other options in here manually as need to wrap headers etc in an option object before sending!
    options.headers = options.headers || {};
    options.dataType = options.dataType || null;
    const axiosOptions = {
      ...options,
      headers: { 'X-Requested-With': 'XMLHttpRequest', ...options.headers },
      ...(options.dataType && { dataType: options.dataType }),
    };
    // This is to break browser cache when you click on "Back button" as this loads JSON rather than the page in some instances
    if (typeof axiosOptions.headers['Cache-Control'] === 'undefined') {
      axiosOptions.headers['Cache-Control'] = 'no-store, no-cache, must-revalidate, max-age=0';
    }
    if (typeof axiosOptions.headers.Expires === 'undefined') {
      axiosOptions.headers.Expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    }
    if (typeof axiosOptions.headers.Pragma === 'undefined') {
      axiosOptions.headers.Pragma = 'no-cache';
    }

    // https://github.com/axios/axios/issues/350#issuecomment-366243396
    if (axiosOptions.headers && axiosOptions.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      axiosOptions.transformRequest = [
        function (data: Record<string, any>) {
          const str = [];
          for (const p in data) {
            if (Object.prototype.hasOwnProperty.call(data, p) && data[p]) {
              str.push(`${encodeURIComponent(p)}=${encodeURIComponent(data[p])}`);
            }
          }
          return str.join('&');
        },
      ];
    }

    axios(axiosOptions)
      .then(result => {
        const response = result.data;
        if (result.status === 204 && response.data === '') {
          response.data = {};
        } else if (typeof response !== 'object') {
          rej(response);
          return;
        }
        result.data = response;
        res(result);
      })
      .catch(e => {
        rej(e);
      });
  });
}
